import * as React from "react";
import { Eye, EyeOff } from "lucide-react";
import { cn } from "../lib/cn";
import { Input } from "./input";

/** Password field with a show/hide toggle (a real button with a pressed state); `noun` names what is hidden ("Show secret"). */
export function PasswordInput({ className, noun = "password", ...props }: Omit<React.ComponentProps<"input">, "type"> & { noun?: string }) {
  const [visible, setVisible] = React.useState(false);
  return (
    <div className="relative">
      <Input {...props} type={visible ? "text" : "password"} className={cn("pr-10", className)} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-pressed={visible}
        className="absolute inset-y-0 right-0 grid w-9 place-items-center rounded-r-md text-fg-faint transition-colors hover:text-fg focus-visible:text-fg [&_svg]:size-4"
      >
        {visible ? <EyeOff aria-hidden /> : <Eye aria-hidden />}
        {/* Named by content, not aria-label, so "label: Password" lookups still find only the field. */}
        <span className="sr-only">{visible ? `Hide ${noun}` : `Show ${noun}`}</span>
      </button>
    </div>
  );
}
